const STATISTICS_VIEWER_POSITIONS = new Set(["CO_FOUNDER", "DIRECTOR", "HR_ADMIN_MANAGER"])

export const canViewRequestStatistics = (position?: null | string) => {
  return Boolean(position && STATISTICS_VIEWER_POSITIONS.has(position))
}

export const toStatisticsVariables = (fromDate: string, toDate: string) => ({
  fromDate,
  toDate,
})

export type StatisticsSortKey = "employee" | "late" | "leave" | "leaveEarly" | "remote"
export type SortDirection = "asc" | "desc"
export type StatisticsSortState = {
  direction: null | SortDirection
  key: null | StatisticsSortKey
}

export const getNextStatisticsSort = (
  current: StatisticsSortState,
  nextKey: StatisticsSortKey,
): StatisticsSortState => {
  if (current.key !== nextKey || !current.direction) {
    return { direction: "desc", key: nextKey }
  }

  if (current.direction === "desc") {
    return { direction: "asc", key: nextKey }
  }

  return { direction: null, key: null }
}

type SortableStatistics = {
  fullName?: null | string
  late: { total: number }
  leave: { total: number }
  leaveEarly: { total: number }
  name: string
  remote: { total: number }
}

export const filterStatisticsByUsers = <T extends { userId: number }>(rows: T[], userIds: number[]) => {
  if (userIds.length === 0) return rows

  const selectedUserIds = new Set(userIds)
  return rows.filter((row) => selectedUserIds.has(row.userId))
}

export const filterUsersWithRequests = <T extends SortableStatistics>(rows: T[]) => {
  return rows.filter((row) => row.leave.total + row.remote.total + row.leaveEarly.total + row.late.total > 0)
}

export const sortStatistics = <T extends SortableStatistics>(
  rows: T[],
  sortKey: StatisticsSortKey,
  direction: SortDirection,
) => {
  const multiplier = direction === "asc" ? 1 : -1

  return [...rows].sort((left, right) => {
    if (sortKey === "employee") {
      const leftName = left.fullName || left.name
      const rightName = right.fullName || right.name
      return leftName.localeCompare(rightName, "vi") * multiplier
    }

    return (left[sortKey].total - right[sortKey].total) * multiplier
  })
}
